'use client'
import { NavLauncher } from './launcher/nav-launcher'
import { useNavContext } from './nav-context-provider'

// The opening surface ships with the bar. Only its contents are deferred:
// a click must never wait for a module download before showing the panel.
export const NavLauncherMount = () => {
  const { isMobile } = useNavContext()

  if (isMobile) {
    return null
  }

  return <NavLauncher />
}
